
import Bold from '@/frontend/components/qecomps/Bold'
import Component, { PageEl } from '@/frontend/components/qecomps/Component'
import Img from '../qecomps/Img';
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {
  return <f-c class={z.styles.hover} style={{backgroundColor:"#f0dfc8",...props.style}} onClick={()=>props.on?.()}>
    <Img src={global.cdn(props.item.icon)} style={{width:40, height:40, borderRadius:4, margin:"4px 5px 0 5px"}}/>
    <c-x>
      <span style={{fontSize:12,}}><Bold>{props.item.title1}</Bold></span>
      <br-xx/>
      <span style={{fontSize:11}}>{props.item.title2}</span>
    </c-x>
  </f-c>
}